import axios from "axios";
import { API_URL } from "../config";

export const login = async (credentials: {
  email: string;
  password: string;
}) => {
  const response = await axios.post(`${API_URL}/api/auth/login`, credentials);
  return response.data;
};
